import { render, staticRenderFns } from "./AtcAutorizeDetail.vue?vue&type=template&id=015ce2e4&"
import script from "./AtcAutorizeDetail.vue?vue&type=script&lang=js&"
export * from "./AtcAutorizeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports